import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { titv_path } from '@routes';
import { TrackingLocation } from '@tracking';
import { LeadTypes } from '@utils/enums';

import type { TITVNetwork } from './Network/interfaces';
import NewsletterSignupCard from './NewsletterSignupCard';
import Partners from './Partners';
import StreamingChannels from './StreamingChannels';
import type { DailyShowDescriptionProps } from './interfaces';

interface DescriptionProps extends DailyShowDescriptionProps {
  titvNetwork: TITVNetwork;
}

const AI_DEEP_DIVE_SLUG = 'ai-deep-dive';

const Description = ({ partnerAds, signupNewsletter, titvNetwork }: DescriptionProps) => {
  const { Track } = useEventTracking({
    location: TrackingLocation.TITVDescription,
  });

  const { description, frequency, slug, title } = titvNetwork;

  const leadType = slug.includes(AI_DEEP_DIVE_SLUG)
    ? LeadTypes.TITVRocketShowNewsletterSignup
    : LeadTypes.TITVLandingRailNewsletterSignup;

  return (
    <Track>
      <div className="mb-20 flex flex-wrap items-center justify-center gap-20 sm:mb-40 sm:flex-nowrap sm:justify-between">
        <div className="mb-16 w-full lg:w-2/3">
          <h1 className="m-0 mb-3 font-suisse-screen text-headline-alt-sm sm:text-headline-alt-md lg:text-headline-alt-lg">
            {title}
          </h1>
          <div className="font-suisse-intl-mono text-overline-md sm:text-overline-lg">
            {frequency}
          </div>
          <div className="my-32 max-w-full sm:max-w-[719px]">
            <p className="m-0 mb-8 font-suisse-neue text-body-lg">{description}</p>
          </div>
        </div>
        <div className="flex w-full flex-col gap-32 sm:w-1/3 sm:shrink-0 lg:w-1/4">
          <div className="mx-auto w-fit">
            <StreamingChannels />
          </div>
          {signupNewsletter && (
            <NewsletterSignupCard
              leadType={leadType}
              newsletter={signupNewsletter}
              redirectToOnSuccess={titv_path()}
            />
          )}
        </div>
      </div>
      {!!partnerAds?.length && <Partners partnerAds={partnerAds} />}
    </Track>
  );
};

export default Description;
